import React, { Component } from 'react';
import { Redirect } from "react-router-dom";

import WrapperTotalLengthPercentChart from '../../content/dashboard/wrapper-total-length-percent-chart/wrapper-total-length-percent-chart.component';
import WrapperCardInfo from '../../content/dashboard/wrapper-card-info/wrapper-card-info.component';
import WrapperTableList from '../../content/dashboard/wrapper-table-list-dashboard/wrapper-table-list.component';
import './dashboard-page.style.css';

class DashboarPage extends Component {

    componentDidMount() {
        
    }

    render() {
        return (
            <div className="wrapper-dashboard-page">
                {/* <h1 className="page-name-header">Dashboards</h1> */}
                {/* <p className="content-test">Lorem ipsum dolor sit amet, consectetur adipiscing elit. ae risus tristique posuere.</p> */}
                {/* <WrapperTotalLengthPercentChart></WrapperTotalLengthPercentChart>
                <WrapperCardInfo></WrapperCardInfo>
                <WrapperTableList></WrapperTableList> */}
                <Redirect to='/pipelinedetail'></Redirect>
            </div>
        )
    }
}

export default DashboarPage
